module.exports = __webpack_public_path__ + "static/media/wb-segunda-franja-spanish.a9043054.svg";